import React from 'react';
import { Filter, Calendar, DollarSign, Users } from 'lucide-react';

const EventFilters = ({ filters, setFilters, eventCounts }) => {
  const categories = ['All', 'Technology', 'Marketing', 'Sustainability', 'Startup', 'Design', 'Leadership'];
  const priceRanges = [
    { label: 'All Prices', min: 0, max: Infinity },
    { label: 'Free', min: 0, max: 0 },
    { label: 'Under $100', min: 0, max: 100 },
    { label: '$100 - $200', min: 100, max: 200 },
    { label: 'Over $200', min: 200, max: Infinity }
  ];

  return React.createElement('div', { className: 'filters-container' },
    React.createElement('div', { className: 'filters-header' },
      React.createElement(Filter, { size: 20 }),
      React.createElement('h3', null, 'Filters')
    ),
    
    React.createElement('div', { className: 'filter-group' },
      React.createElement('div', { className: 'filter-label' },
        React.createElement(Users, { size: 16 }),
        'Category'
      ),
      React.createElement('div', { className: 'filter-options' },
        categories.map(category =>
          React.createElement('button', {
            key: category,
            onClick: () => setFilters(prev => ({ ...prev, category })),
            className: `filter-option ${filters.category === category ? 'active' : ''}`
          },
            category,
            eventCounts[category] &&
              React.createElement('span', { className: 'filter-count' }, eventCounts[category])
          )
        )
      )
    ),
    
    React.createElement('div', { className: 'filter-group' },
      React.createElement('div', { className: 'filter-label' },
        React.createElement(DollarSign, { size: 16 }),
        'Price Range'
      ),
      React.createElement('div', { className: 'filter-options' },
        priceRanges.map((range, index) =>
          React.createElement('button', {
            key: index,
            onClick: () => setFilters(prev => ({ 
              ...prev, 
              priceRange: { min: range.min, max: range.max }
            })),
            className: `filter-option ${
              filters.priceRange.min === range.min && 
              filters.priceRange.max === range.max ? 'active' : ''
            }`
          }, range.label)
        )
      )
    ),
    
    React.createElement('div', { className: 'filter-group' },
      React.createElement('div', { className: 'filter-label' },
        React.createElement(Calendar, { size: 16 }),
        'Date Range'
      ),
      React.createElement('div', { className: 'date-inputs' },
        React.createElement('input', {
          type: 'date',
          value: filters.dateRange.start,
          onChange: (e) => setFilters(prev => ({
            ...prev,
            dateRange: { ...prev.dateRange, start: e.target.value }
          })),
          className: 'date-input'
        }),
        React.createElement('input', {
          type: 'date',
          value: filters.dateRange.end,
          onChange: (e) => setFilters(prev => ({
            ...prev,
            dateRange: { ...prev.dateRange, end: e.target.value }
          })),
          className: 'date-input'
        })
      )
    ),
    
    React.createElement('button', {
      onClick: () => setFilters({
        category: 'All',
        priceRange: { min: 0, max: Infinity },
        dateRange: { start: '', end: '' }
      }),
      className: 'btn-reset'
    }, 'Reset Filters')
  );
};

export default EventFilters;